import { Icon } from '@iconify/react'
import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import useReactApexChart from '../../hook/useReactApexChart'
import { useAuth } from '../../context/AuthContext'
import config from '../../config'

const TotalSubscriberOne = () => {
    let { barChartSeries, barChartOptions } = useReactApexChart()
    const { auth } = useAuth();
    const [series, setSeries] = useState(barChartSeries);
    const [options, setOptions] = useState(barChartOptions);
    const [totalSubscribers, setTotalSubscribers] = useState(0);
    const [percentageChange, setPercentageChange] = useState(0);
    const [avgDaily, setAvgDaily] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await auth.fetch(`${config.API_BASE_URL}/api/users/subscriber-stats`);
                if (response.ok) {
                    const data = await response.json();
                    setSeries(data.series);
                    setTotalSubscribers(data.total);
                    setPercentageChange(data.percentage_change || 0);
                    setAvgDaily(data.avg_daily || 0);
                    
                    setOptions(prev => ({
                        ...prev,
                        xaxis: {
                            ...prev.xaxis,
                            categories: data.categories
                        }
                    }));
                }
            } catch (error) {
                console.error('Failed to fetch subscriber stats:', error);
            }
        };

        fetchData();
    }, [auth]);

    const isPositive = percentageChange >= 0;

    return (
        <div className="col-xxl-3 col-xl-6">
            <div className="card h-100 radius-8 border">
                <div className="card-body p-24">
                    <h6 className="mb-12 fw-semibold text-lg mb-16">Total Subscriber</h6>
                    <div className="d-flex align-items-center gap-2 mb-20">
                        <h6 className="fw-semibold mb-0">{totalSubscribers.toLocaleString()}</h6>
                        <p className="text-sm mb-0">
                            <span className={`${isPositive ? 'bg-success-focus border br-success text-success-main' : 'bg-danger-focus border br-danger text-danger-main'} px-8 py-2 rounded-pill fw-semibold text-sm d-inline-flex align-items-center gap-1`}>
                                {Math.abs(percentageChange)}%
                                <Icon
                                    icon={isPositive ? "iconamoon:arrow-up-2-fill" : "iconamoon:arrow-down-2-fill"}
                                    className="icon"
                                />
                            </span>
                            - {avgDaily} Per Day
                        </p>
                    </div>
                    <ReactApexChart options={options} series={series} type="bar" height={264} />
                </div>
            </div>
        </div>
    )
}

export default TotalSubscriberOne